"use client";
import { useRef } from "react";
import { motion } from "framer-motion";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@packages/ui/src/components/shadcn/carousel";
import { PartnerCard } from "./PartnerCard";
import { partnersData } from "./partners";

const AUTOPLAY_OPTIONS = { delay: 2500, stopOnInteraction: true };

export function PartnersCarousel() {
  const plugin = useRef(Autoplay(AUTOPLAY_OPTIONS));

  return (
    <section
      id="partners"
      aria-labelledby="partners-heading"
      className="w-full py-12 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center mb-6"
        >
          <h2
            id="partners-heading"
            className="text-sm md:text-base font-semibold tracking-widest text-blue-600 uppercase"
          >
            Transforming the Remote Working
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative px-8"
        >
          <Carousel
            plugins={[plugin.current]}
            opts={{ align: "start", loop: true }}
            className="w-full"
          >
            <CarouselContent className="-ml-4">
              {partnersData.map((partner) => (
                <CarouselItem
                  key={partner.id}
                  className="basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5 pl-4 py-1"
                >
                  <PartnerCard partner={partner} />
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </motion.div>
      </div>
    </section>
  );
}
